__turbopack_context__.v({
  "actionButton": "SchoolFeedContactCard-module-scss-module__Dl-HPq__actionButton",
  "blocksBackgroundColor": "SchoolFeedContactCard-module-scss-module__Dl-HPq__blocksBackgroundColor",
  "blocksFontColor": "SchoolFeedContactCard-module-scss-module__Dl-HPq__blocksFontColor",
  "buttonRow": "SchoolFeedContactCard-module-scss-module__Dl-HPq__buttonRow",
  "cardContent": "SchoolFeedContactCard-module-scss-module__Dl-HPq__cardContent",
  "descriptionSection": "SchoolFeedContactCard-module-scss-module__Dl-HPq__descriptionSection",
  "eventsWidget": "SchoolFeedContactCard-module-scss-module__Dl-HPq__eventsWidget",
  "header": "SchoolFeedContactCard-module-scss-module__Dl-HPq__header",
  "orgDescription": "SchoolFeedContactCard-module-scss-module__Dl-HPq__orgDescription",
  "orgDescriptionPlaceholder": "SchoolFeedContactCard-module-scss-module__Dl-HPq__orgDescriptionPlaceholder",
  "schoolFeedContactCardContainer": "SchoolFeedContactCard-module-scss-module__Dl-HPq__schoolFeedContactCardContainer",
  "secondaryNavBackgroundColor": "SchoolFeedContactCard-module-scss-module__Dl-HPq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SchoolFeedContactCard-module-scss-module__Dl-HPq__themeBackgroundColor",
  "themeFontColor": "SchoolFeedContactCard-module-scss-module__Dl-HPq__themeFontColor",
  "upcomingNews": "SchoolFeedContactCard-module-scss-module__Dl-HPq__upcomingNews",
  "widget": "SchoolFeedContactCard-module-scss-module__Dl-HPq__widget",
});
